import * as is from 'is_js';

export const isChromeCompatible = is.edge() || is.chrome() || is.firefox();
export const getBrowserClientId = () => localStorage.getItem('BROWSER_CLIENT_ID') || '';
